/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Artic
 * The Artic API documentation
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ApplySuggestedCategoriesDto,
  ApplySuggestedCategoriesResultDto,
  BooControllerGetMatrixParams,
  BooControllerGetWorkloadDiagnosticsParams,
  BooControllerGetWorkloadForecastParams,
  BooControllerGetWorkloadThresholdsParams,
  BooControllerListRulesParams,
  BooMatrixResponseDto,
  CreateRelevanceRuleDto,
  ProductOperationOverrideInputDto,
  RelevanceRuleDto,
  WorkloadDiagnosticsResponseDto,
  WorkloadForecastResponseDto,
  WorkloadThresholdsResponseDto
} from '.././schemas';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Returns a dense operations × products applicability matrix for the partner. Each cell carries a source (rule_include, rule_exclude, override_exclude, legacy_junction, no_match) and any associated rule_id / override values. Use the limit parameter to cap the number of products returned (default 200).
 * @summary Get the Run Sheet relevance matrix for a partner
 */
export type booControllerGetMatrixResponse200 = {
  data: BooMatrixResponseDto
  status: 200
}

export type booControllerGetMatrixResponse400 = {
  data: void
  status: 400
}

export type booControllerGetMatrixResponse401 = {
  data: void
  status: 401
}

export type booControllerGetMatrixResponse404 = {
  data: void
  status: 404
}
    
export type booControllerGetMatrixResponseSuccess = (booControllerGetMatrixResponse200) & {
  headers: Headers;
};
export type booControllerGetMatrixResponseError = (booControllerGetMatrixResponse400 | booControllerGetMatrixResponse401 | booControllerGetMatrixResponse404) & {
  headers: Headers;
};

export type booControllerGetMatrixResponse = (booControllerGetMatrixResponseSuccess | booControllerGetMatrixResponseError)

export const getBooControllerGetMatrixUrl = (params: BooControllerGetMatrixParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/boo/matrix?${stringifiedParams}` : `/boo/matrix`
}

export const booControllerGetMatrix = async (params: BooControllerGetMatrixParams, options?: RequestInit): Promise<booControllerGetMatrixResponse> => {
  
  return customFetch<booControllerGetMatrixResponse>(getBooControllerGetMatrixUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getBooControllerGetMatrixQueryKey = (params?: BooControllerGetMatrixParams,) => {
    return [
    `/boo/matrix`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getBooControllerGetMatrixQueryOptions = <TData = Awaited<ReturnType<typeof booControllerGetMatrix>>, TError = void>(params: BooControllerGetMatrixParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof booControllerGetMatrix>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBooControllerGetMatrixQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof booControllerGetMatrix>>> = ({ signal }) => booControllerGetMatrix(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof booControllerGetMatrix>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type BooControllerGetMatrixQueryResult = NonNullable<Awaited<ReturnType<typeof booControllerGetMatrix>>>
export type BooControllerGetMatrixQueryError = void


export function useBooControllerGetMatrix<TData = Awaited<ReturnType<typeof booControllerGetMatrix>>, TError = void>(
 params: BooControllerGetMatrixParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof booControllerGetMatrix>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof booControllerGetMatrix>>,
          TError,
          Awaited<ReturnType<typeof booControllerGetMatrix>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useBooControllerGetMatrix<TData = Awaited<ReturnType<typeof booControllerGetMatrix>>, TError = void>(
 params: BooControllerGetMatrixParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof booControllerGetMatrix>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof booControllerGetMatrix>>,
          TError,
          Awaited<ReturnType<typeof booControllerGetMatrix>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useBooControllerGetMatrix<TData = Awaited<ReturnType<typeof booControllerGetMatrix>>, TError = void>(
 params: BooControllerGetMatrixParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof booControllerGetMatrix>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get the Run Sheet relevance matrix for a partner
 */

export function useBooControllerGetMatrix<TData = Awaited<ReturnType<typeof booControllerGetMatrix>>, TError = void>(
 params: BooControllerGetMatrixParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof booControllerGetMatrix>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getBooControllerGetMatrixQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get the Run Sheet relevance matrix for a partner
 */
export const prefetchBooControllerGetMatrixQuery = async <TData = Awaited<ReturnType<typeof booControllerGetMatrix>>, TError = void>(
 queryClient: QueryClient, params: BooControllerGetMatrixParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof booControllerGetMatrix>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getBooControllerGetMatrixQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getBooControllerGetMatrixSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof booControllerGetMatrix>>, TError = void>(params: BooControllerGetMatrixParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof booControllerGetMatrix>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBooControllerGetMatrixQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof booControllerGetMatrix>>> = ({ signal }) => booControllerGetMatrix(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof booControllerGetMatrix>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type BooControllerGetMatrixSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof booControllerGetMatrix>>>
export type BooControllerGetMatrixSuspenseQueryError = void


export function useBooControllerGetMatrixSuspense<TData = Awaited<ReturnType<typeof booControllerGetMatrix>>, TError = void>(
 params: BooControllerGetMatrixParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof booControllerGetMatrix>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useBooControllerGetMatrixSuspense<TData = Awaited<ReturnType<typeof booControllerGetMatrix>>, TError = void>(
 params: BooControllerGetMatrixParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof booControllerGetMatrix>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useBooControllerGetMatrixSuspense<TData = Awaited<ReturnType<typeof booControllerGetMatrix>>, TError = void>(
 params: BooControllerGetMatrixParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof booControllerGetMatrix>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get the Run Sheet relevance matrix for a partner
 */

export function useBooControllerGetMatrixSuspense<TData = Awaited<ReturnType<typeof booControllerGetMatrix>>, TError = void>(
 params: BooControllerGetMatrixParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof booControllerGetMatrix>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getBooControllerGetMatrixSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Returns the partner-wide percentile cuts (p30/p60/p85/p95), per-band population statistics, and a readiness flag for each product type that has at least one banded run sheet. Thin wrapper over the same distribution the matrix embeds. Requires admin or partner membership.
 * @summary Get per-product-type workload band thresholds for a partner
 */
export type booControllerGetWorkloadThresholdsResponse200 = {
  data: WorkloadThresholdsResponseDto
  status: 200
}

export type booControllerGetWorkloadThresholdsResponse401 = {
  data: void
  status: 401
}

export type booControllerGetWorkloadThresholdsResponse403 = {
  data: void
  status: 403
}

export type booControllerGetWorkloadThresholdsResponse404 = {
  data: void
  status: 404
}
    
export type booControllerGetWorkloadThresholdsResponseSuccess = (booControllerGetWorkloadThresholdsResponse200) & {
  headers: Headers;
};
export type booControllerGetWorkloadThresholdsResponseError = (booControllerGetWorkloadThresholdsResponse401 | booControllerGetWorkloadThresholdsResponse403 | booControllerGetWorkloadThresholdsResponse404) & {
  headers: Headers;
};

export type booControllerGetWorkloadThresholdsResponse = (booControllerGetWorkloadThresholdsResponseSuccess | booControllerGetWorkloadThresholdsResponseError)

export const getBooControllerGetWorkloadThresholdsUrl = (params: BooControllerGetWorkloadThresholdsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/boo/workload/thresholds?${stringifiedParams}` : `/boo/workload/thresholds`
}

export const booControllerGetWorkloadThresholds = async (params: BooControllerGetWorkloadThresholdsParams, options?: RequestInit): Promise<booControllerGetWorkloadThresholdsResponse> => {
  
  return customFetch<booControllerGetWorkloadThresholdsResponse>(getBooControllerGetWorkloadThresholdsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getBooControllerGetWorkloadThresholdsQueryKey = (params?: BooControllerGetWorkloadThresholdsParams,) => {
    return [
    `/boo/workload/thresholds`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getBooControllerGetWorkloadThresholdsQueryOptions = <TData = Awaited<ReturnType<typeof booControllerGetWorkloadThresholds>>, TError = void>(params: BooControllerGetWorkloadThresholdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof booControllerGetWorkloadThresholds>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBooControllerGetWorkloadThresholdsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof booControllerGetWorkloadThresholds>>> = ({ signal }) => booControllerGetWorkloadThresholds(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof booControllerGetWorkloadThresholds>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type BooControllerGetWorkloadThresholdsQueryResult = NonNullable<Awaited<ReturnType<typeof booControllerGetWorkloadThresholds>>>
export type BooControllerGetWorkloadThresholdsQueryError = void


export function useBooControllerGetWorkloadThresholds<TData = Awaited<ReturnType<typeof booControllerGetWorkloadThresholds>>, TError = void>(
 params: BooControllerGetWorkloadThresholdsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof booControllerGetWorkloadThresholds>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof booControllerGetWorkloadThresholds>>,
          TError,
          Awaited<ReturnType<typeof booControllerGetWorkloadThresholds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useBooControllerGetWorkloadThresholds<TData = Awaited<ReturnType<typeof booControllerGetWorkloadThresholds>>, TError = void>(
 params: BooControllerGetWorkloadThresholdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof booControllerGetWorkloadThresholds>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof booControllerGetWorkloadThresholds>>,
          TError,
          Awaited<ReturnType<typeof booControllerGetWorkloadThresholds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useBooControllerGetWorkloadThresholds<TData = Awaited<ReturnType<typeof booControllerGetWorkloadThresholds>>, TError = void>(
 params: BooControllerGetWorkloadThresholdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof booControllerGetWorkloadThresholds>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get per-product-type workload band thresholds for a partner
 */

export function useBooControllerGetWorkloadThresholds<TData = Awaited<ReturnType<typeof booControllerGetWorkloadThresholds>>, TError = void>(
 params: BooControllerGetWorkloadThresholdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof booControllerGetWorkloadThresholds>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getBooControllerGetWorkloadThresholdsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get per-product-type workload band thresholds for a partner
 */
export const prefetchBooControllerGetWorkloadThresholdsQuery = async <TData = Awaited<ReturnType<typeof booControllerGetWorkloadThresholds>>, TError = void>(
 queryClient: QueryClient, params: BooControllerGetWorkloadThresholdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof booControllerGetWorkloadThresholds>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getBooControllerGetWorkloadThresholdsQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getBooControllerGetWorkloadThresholdsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof booControllerGetWorkloadThresholds>>, TError = void>(params: BooControllerGetWorkloadThresholdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof booControllerGetWorkloadThresholds>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBooControllerGetWorkloadThresholdsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof booControllerGetWorkloadThresholds>>> = ({ signal }) => booControllerGetWorkloadThresholds(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof booControllerGetWorkloadThresholds>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type BooControllerGetWorkloadThresholdsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof booControllerGetWorkloadThresholds>>>
export type BooControllerGetWorkloadThresholdsSuspenseQueryError = void


export function useBooControllerGetWorkloadThresholdsSuspense<TData = Awaited<ReturnType<typeof booControllerGetWorkloadThresholds>>, TError = void>(
 params: BooControllerGetWorkloadThresholdsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof booControllerGetWorkloadThresholds>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useBooControllerGetWorkloadThresholdsSuspense<TData = Awaited<ReturnType<typeof booControllerGetWorkloadThresholds>>, TError = void>(
 params: BooControllerGetWorkloadThresholdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof booControllerGetWorkloadThresholds>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useBooControllerGetWorkloadThresholdsSuspense<TData = Awaited<ReturnType<typeof booControllerGetWorkloadThresholds>>, TError = void>(
 params: BooControllerGetWorkloadThresholdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof booControllerGetWorkloadThresholds>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get per-product-type workload band thresholds for a partner
 */

export function useBooControllerGetWorkloadThresholdsSuspense<TData = Awaited<ReturnType<typeof booControllerGetWorkloadThresholds>>, TError = void>(
 params: BooControllerGetWorkloadThresholdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof booControllerGetWorkloadThresholds>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getBooControllerGetWorkloadThresholdsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Forecasts a run sheet's planned total labour minutes and workload category from the pool of built run sheets of the given product type whose container selections are a superset of the ones selected so far, falling back to the whole-type pool when no closer match exists. Returns the confidence ladder (baseline/low/confident) plus the ± spread and the context the planner UI needs to explain it. Requires admin or partner membership.
 * @summary Progressive workload forecast for a run sheet being planned
 */
export type booControllerGetWorkloadForecastResponse200 = {
  data: WorkloadForecastResponseDto
  status: 200
}

export type booControllerGetWorkloadForecastResponse401 = {
  data: void
  status: 401
}

export type booControllerGetWorkloadForecastResponse403 = {
  data: void
  status: 403
}

export type booControllerGetWorkloadForecastResponse404 = {
  data: void
  status: 404
}
    
export type booControllerGetWorkloadForecastResponseSuccess = (booControllerGetWorkloadForecastResponse200) & {
  headers: Headers;
};
export type booControllerGetWorkloadForecastResponseError = (booControllerGetWorkloadForecastResponse401 | booControllerGetWorkloadForecastResponse403 | booControllerGetWorkloadForecastResponse404) & {
  headers: Headers;
};

export type booControllerGetWorkloadForecastResponse = (booControllerGetWorkloadForecastResponseSuccess | booControllerGetWorkloadForecastResponseError)

export const getBooControllerGetWorkloadForecastUrl = (params: BooControllerGetWorkloadForecastParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/boo/workload/forecast?${stringifiedParams}` : `/boo/workload/forecast`
}

export const booControllerGetWorkloadForecast = async (params: BooControllerGetWorkloadForecastParams, options?: RequestInit): Promise<booControllerGetWorkloadForecastResponse> => {
  
  return customFetch<booControllerGetWorkloadForecastResponse>(getBooControllerGetWorkloadForecastUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getBooControllerGetWorkloadForecastQueryKey = (params?: BooControllerGetWorkloadForecastParams,) => {
    return [
    `/boo/workload/forecast`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getBooControllerGetWorkloadForecastQueryOptions = <TData = Awaited<ReturnType<typeof booControllerGetWorkloadForecast>>, TError = void>(params: BooControllerGetWorkloadForecastParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof booControllerGetWorkloadForecast>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBooControllerGetWorkloadForecastQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof booControllerGetWorkloadForecast>>> = ({ signal }) => booControllerGetWorkloadForecast(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof booControllerGetWorkloadForecast>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type BooControllerGetWorkloadForecastQueryResult = NonNullable<Awaited<ReturnType<typeof booControllerGetWorkloadForecast>>>
export type BooControllerGetWorkloadForecastQueryError = void


export function useBooControllerGetWorkloadForecast<TData = Awaited<ReturnType<typeof booControllerGetWorkloadForecast>>, TError = void>(
 params: BooControllerGetWorkloadForecastParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof booControllerGetWorkloadForecast>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof booControllerGetWorkloadForecast>>,
          TError,
          Awaited<ReturnType<typeof booControllerGetWorkloadForecast>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useBooControllerGetWorkloadForecast<TData = Awaited<ReturnType<typeof booControllerGetWorkloadForecast>>, TError = void>(
 params: BooControllerGetWorkloadForecastParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof booControllerGetWorkloadForecast>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof booControllerGetWorkloadForecast>>,
          TError,
          Awaited<ReturnType<typeof booControllerGetWorkloadForecast>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useBooControllerGetWorkloadForecast<TData = Awaited<ReturnType<typeof booControllerGetWorkloadForecast>>, TError = void>(
 params: BooControllerGetWorkloadForecastParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof booControllerGetWorkloadForecast>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Progressive workload forecast for a run sheet being planned
 */

export function useBooControllerGetWorkloadForecast<TData = Awaited<ReturnType<typeof booControllerGetWorkloadForecast>>, TError = void>(
 params: BooControllerGetWorkloadForecastParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof booControllerGetWorkloadForecast>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getBooControllerGetWorkloadForecastQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Progressive workload forecast for a run sheet being planned
 */
export const prefetchBooControllerGetWorkloadForecastQuery = async <TData = Awaited<ReturnType<typeof booControllerGetWorkloadForecast>>, TError = void>(
 queryClient: QueryClient, params: BooControllerGetWorkloadForecastParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof booControllerGetWorkloadForecast>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getBooControllerGetWorkloadForecastQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getBooControllerGetWorkloadForecastSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof booControllerGetWorkloadForecast>>, TError = void>(params: BooControllerGetWorkloadForecastParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof booControllerGetWorkloadForecast>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBooControllerGetWorkloadForecastQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof booControllerGetWorkloadForecast>>> = ({ signal }) => booControllerGetWorkloadForecast(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof booControllerGetWorkloadForecast>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type BooControllerGetWorkloadForecastSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof booControllerGetWorkloadForecast>>>
export type BooControllerGetWorkloadForecastSuspenseQueryError = void


export function useBooControllerGetWorkloadForecastSuspense<TData = Awaited<ReturnType<typeof booControllerGetWorkloadForecast>>, TError = void>(
 params: BooControllerGetWorkloadForecastParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof booControllerGetWorkloadForecast>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useBooControllerGetWorkloadForecastSuspense<TData = Awaited<ReturnType<typeof booControllerGetWorkloadForecast>>, TError = void>(
 params: BooControllerGetWorkloadForecastParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof booControllerGetWorkloadForecast>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useBooControllerGetWorkloadForecastSuspense<TData = Awaited<ReturnType<typeof booControllerGetWorkloadForecast>>, TError = void>(
 params: BooControllerGetWorkloadForecastParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof booControllerGetWorkloadForecast>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Progressive workload forecast for a run sheet being planned
 */

export function useBooControllerGetWorkloadForecastSuspense<TData = Awaited<ReturnType<typeof booControllerGetWorkloadForecast>>, TError = void>(
 params: BooControllerGetWorkloadForecastParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof booControllerGetWorkloadForecast>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getBooControllerGetWorkloadForecastSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Exposes the per-product populations, exclusions, confirmed-vs-computed categories, and recent recalibrations behind the workload banding calculation, for the admin workload-categories debug view. Composes data already computed by WorkloadBandsService — no new maths. Requires admin or partner membership.
 * @summary Get the raw inputs behind workload category banding for a partner (ENG-554)
 */
export type booControllerGetWorkloadDiagnosticsResponse200 = {
  data: WorkloadDiagnosticsResponseDto
  status: 200
}

export type booControllerGetWorkloadDiagnosticsResponse401 = {
  data: void
  status: 401
}

export type booControllerGetWorkloadDiagnosticsResponse403 = {
  data: void
  status: 403
}

export type booControllerGetWorkloadDiagnosticsResponse404 = {
  data: void
  status: 404
}
    
export type booControllerGetWorkloadDiagnosticsResponseSuccess = (booControllerGetWorkloadDiagnosticsResponse200) & {
  headers: Headers;
};
export type booControllerGetWorkloadDiagnosticsResponseError = (booControllerGetWorkloadDiagnosticsResponse401 | booControllerGetWorkloadDiagnosticsResponse403 | booControllerGetWorkloadDiagnosticsResponse404) & {
  headers: Headers;
};

export type booControllerGetWorkloadDiagnosticsResponse = (booControllerGetWorkloadDiagnosticsResponseSuccess | booControllerGetWorkloadDiagnosticsResponseError)

export const getBooControllerGetWorkloadDiagnosticsUrl = (params: BooControllerGetWorkloadDiagnosticsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/boo/workload/diagnostics?${stringifiedParams}` : `/boo/workload/diagnostics`
}

export const booControllerGetWorkloadDiagnostics = async (params: BooControllerGetWorkloadDiagnosticsParams, options?: RequestInit): Promise<booControllerGetWorkloadDiagnosticsResponse> => {
  
  return customFetch<booControllerGetWorkloadDiagnosticsResponse>(getBooControllerGetWorkloadDiagnosticsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getBooControllerGetWorkloadDiagnosticsQueryKey = (params?: BooControllerGetWorkloadDiagnosticsParams,) => {
    return [
    `/boo/workload/diagnostics`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getBooControllerGetWorkloadDiagnosticsQueryOptions = <TData = Awaited<ReturnType<typeof booControllerGetWorkloadDiagnostics>>, TError = void>(params: BooControllerGetWorkloadDiagnosticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof booControllerGetWorkloadDiagnostics>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBooControllerGetWorkloadDiagnosticsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof booControllerGetWorkloadDiagnostics>>> = ({ signal }) => booControllerGetWorkloadDiagnostics(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof booControllerGetWorkloadDiagnostics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type BooControllerGetWorkloadDiagnosticsQueryResult = NonNullable<Awaited<ReturnType<typeof booControllerGetWorkloadDiagnostics>>>
export type BooControllerGetWorkloadDiagnosticsQueryError = void


export function useBooControllerGetWorkloadDiagnostics<TData = Awaited<ReturnType<typeof booControllerGetWorkloadDiagnostics>>, TError = void>(
 params: BooControllerGetWorkloadDiagnosticsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof booControllerGetWorkloadDiagnostics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof booControllerGetWorkloadDiagnostics>>,
          TError,
          Awaited<ReturnType<typeof booControllerGetWorkloadDiagnostics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useBooControllerGetWorkloadDiagnostics<TData = Awaited<ReturnType<typeof booControllerGetWorkloadDiagnostics>>, TError = void>(
 params: BooControllerGetWorkloadDiagnosticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof booControllerGetWorkloadDiagnostics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof booControllerGetWorkloadDiagnostics>>,
          TError,
          Awaited<ReturnType<typeof booControllerGetWorkloadDiagnostics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useBooControllerGetWorkloadDiagnostics<TData = Awaited<ReturnType<typeof booControllerGetWorkloadDiagnostics>>, TError = void>(
 params: BooControllerGetWorkloadDiagnosticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof booControllerGetWorkloadDiagnostics>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get the raw inputs behind workload category banding for a partner (ENG-554)
 */

export function useBooControllerGetWorkloadDiagnostics<TData = Awaited<ReturnType<typeof booControllerGetWorkloadDiagnostics>>, TError = void>(
 params: BooControllerGetWorkloadDiagnosticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof booControllerGetWorkloadDiagnostics>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getBooControllerGetWorkloadDiagnosticsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get the raw inputs behind workload category banding for a partner (ENG-554)
 */
export const prefetchBooControllerGetWorkloadDiagnosticsQuery = async <TData = Awaited<ReturnType<typeof booControllerGetWorkloadDiagnostics>>, TError = void>(
 queryClient: QueryClient, params: BooControllerGetWorkloadDiagnosticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof booControllerGetWorkloadDiagnostics>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getBooControllerGetWorkloadDiagnosticsQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getBooControllerGetWorkloadDiagnosticsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof booControllerGetWorkloadDiagnostics>>, TError = void>(params: BooControllerGetWorkloadDiagnosticsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof booControllerGetWorkloadDiagnostics>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBooControllerGetWorkloadDiagnosticsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof booControllerGetWorkloadDiagnostics>>> = ({ signal }) => booControllerGetWorkloadDiagnostics(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof booControllerGetWorkloadDiagnostics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type BooControllerGetWorkloadDiagnosticsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof booControllerGetWorkloadDiagnostics>>>
export type BooControllerGetWorkloadDiagnosticsSuspenseQueryError = void


export function useBooControllerGetWorkloadDiagnosticsSuspense<TData = Awaited<ReturnType<typeof booControllerGetWorkloadDiagnostics>>, TError = void>(
 params: BooControllerGetWorkloadDiagnosticsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof booControllerGetWorkloadDiagnostics>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useBooControllerGetWorkloadDiagnosticsSuspense<TData = Awaited<ReturnType<typeof booControllerGetWorkloadDiagnostics>>, TError = void>(
 params: BooControllerGetWorkloadDiagnosticsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof booControllerGetWorkloadDiagnostics>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useBooControllerGetWorkloadDiagnosticsSuspense<TData = Awaited<ReturnType<typeof booControllerGetWorkloadDiagnostics>>, TError = void>(
 params: BooControllerGetWorkloadDiagnosticsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof booControllerGetWorkloadDiagnostics>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get the raw inputs behind workload category banding for a partner (ENG-554)
 */

export function useBooControllerGetWorkloadDiagnosticsSuspense<TData = Awaited<ReturnType<typeof booControllerGetWorkloadDiagnostics>>, TError = void>(
 params: BooControllerGetWorkloadDiagnosticsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof booControllerGetWorkloadDiagnostics>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getBooControllerGetWorkloadDiagnosticsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Confirms the suggested workload category on every applied, unconfirmed cell — scoped to the given product_ids (per-product Apply All) or the whole partner when omitted (global Apply All). Already-confirmed cells are never overwritten; cycle-time/headcount overrides are preserved. All-or-nothing per request.
 * @summary Apply all suggested workload categories (ENG-609)
 */
export type booControllerApplySuggestedCategoriesResponse200 = {
  data: ApplySuggestedCategoriesResultDto
  status: 200
}

export type booControllerApplySuggestedCategoriesResponse401 = {
  data: void
  status: 401
}

export type booControllerApplySuggestedCategoriesResponse404 = {
  data: void
  status: 404
}
    
export type booControllerApplySuggestedCategoriesResponseSuccess = (booControllerApplySuggestedCategoriesResponse200) & {
  headers: Headers;
};
export type booControllerApplySuggestedCategoriesResponseError = (booControllerApplySuggestedCategoriesResponse401 | booControllerApplySuggestedCategoriesResponse404) & {
  headers: Headers;
};

export type booControllerApplySuggestedCategoriesResponse = (booControllerApplySuggestedCategoriesResponseSuccess | booControllerApplySuggestedCategoriesResponseError)

export const getBooControllerApplySuggestedCategoriesUrl = () => {


  

  return `/boo/overrides/apply-suggested`
}

export const booControllerApplySuggestedCategories = async (applySuggestedCategoriesDto: ApplySuggestedCategoriesDto, options?: RequestInit): Promise<booControllerApplySuggestedCategoriesResponse> => {
  
  return customFetch<booControllerApplySuggestedCategoriesResponse>(getBooControllerApplySuggestedCategoriesUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      applySuggestedCategoriesDto,)
  }
);}




export const getBooControllerApplySuggestedCategoriesMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof booControllerApplySuggestedCategories>>, TError,{data: ApplySuggestedCategoriesDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof booControllerApplySuggestedCategories>>, TError,{data: ApplySuggestedCategoriesDto}, TContext> => {

const mutationKey = ['booControllerApplySuggestedCategories'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof booControllerApplySuggestedCategories>>, {data: ApplySuggestedCategoriesDto}> = (props) => {
          const {data} = props ?? {};

          return  booControllerApplySuggestedCategories(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BooControllerApplySuggestedCategoriesMutationResult = NonNullable<Awaited<ReturnType<typeof booControllerApplySuggestedCategories>>>
    export type BooControllerApplySuggestedCategoriesMutationBody = ApplySuggestedCategoriesDto
    export type BooControllerApplySuggestedCategoriesMutationError = void

    /**
 * @summary Apply all suggested workload categories (ENG-609)
 */
export const useBooControllerApplySuggestedCategories = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof booControllerApplySuggestedCategories>>, TError,{data: ApplySuggestedCategoriesDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof booControllerApplySuggestedCategories>>,
        TError,
        {data: ApplySuggestedCategoriesDto},
        TContext
      > => {

      const mutationOptions = getBooControllerApplySuggestedCategoriesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Returns all relevance rules for the partner. Requires admin or partner membership.
 * @summary List relevance rules for a partner
 */
export type booControllerListRulesResponse200 = {
  data: RelevanceRuleDto[]
  status: 200
}

export type booControllerListRulesResponse401 = {
  data: void
  status: 401
}

export type booControllerListRulesResponse403 = {
  data: void
  status: 403
}
    
export type booControllerListRulesResponseSuccess = (booControllerListRulesResponse200) & {
  headers: Headers;
};
export type booControllerListRulesResponseError = (booControllerListRulesResponse401 | booControllerListRulesResponse403) & {
  headers: Headers;
};

export type booControllerListRulesResponse = (booControllerListRulesResponseSuccess | booControllerListRulesResponseError)

export const getBooControllerListRulesUrl = (params: BooControllerListRulesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/boo/rules?${stringifiedParams}` : `/boo/rules`
}

export const booControllerListRules = async (params: BooControllerListRulesParams, options?: RequestInit): Promise<booControllerListRulesResponse> => {
  
  return customFetch<booControllerListRulesResponse>(getBooControllerListRulesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getBooControllerListRulesQueryKey = (params?: BooControllerListRulesParams,) => {
    return [
    `/boo/rules`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getBooControllerListRulesQueryOptions = <TData = Awaited<ReturnType<typeof booControllerListRules>>, TError = void>(params: BooControllerListRulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof booControllerListRules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBooControllerListRulesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof booControllerListRules>>> = ({ signal }) => booControllerListRules(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof booControllerListRules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type BooControllerListRulesQueryResult = NonNullable<Awaited<ReturnType<typeof booControllerListRules>>>
export type BooControllerListRulesQueryError = void


export function useBooControllerListRules<TData = Awaited<ReturnType<typeof booControllerListRules>>, TError = void>(
 params: BooControllerListRulesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof booControllerListRules>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof booControllerListRules>>,
          TError,
          Awaited<ReturnType<typeof booControllerListRules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useBooControllerListRules<TData = Awaited<ReturnType<typeof booControllerListRules>>, TError = void>(
 params: BooControllerListRulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof booControllerListRules>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof booControllerListRules>>,
          TError,
          Awaited<ReturnType<typeof booControllerListRules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useBooControllerListRules<TData = Awaited<ReturnType<typeof booControllerListRules>>, TError = void>(
 params: BooControllerListRulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof booControllerListRules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List relevance rules for a partner
 */

export function useBooControllerListRules<TData = Awaited<ReturnType<typeof booControllerListRules>>, TError = void>(
 params: BooControllerListRulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof booControllerListRules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getBooControllerListRulesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary List relevance rules for a partner
 */
export const prefetchBooControllerListRulesQuery = async <TData = Awaited<ReturnType<typeof booControllerListRules>>, TError = void>(
 queryClient: QueryClient, params: BooControllerListRulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof booControllerListRules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getBooControllerListRulesQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getBooControllerListRulesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof booControllerListRules>>, TError = void>(params: BooControllerListRulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof booControllerListRules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBooControllerListRulesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof booControllerListRules>>> = ({ signal }) => booControllerListRules(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof booControllerListRules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type BooControllerListRulesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof booControllerListRules>>>
export type BooControllerListRulesSuspenseQueryError = void


export function useBooControllerListRulesSuspense<TData = Awaited<ReturnType<typeof booControllerListRules>>, TError = void>(
 params: BooControllerListRulesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof booControllerListRules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useBooControllerListRulesSuspense<TData = Awaited<ReturnType<typeof booControllerListRules>>, TError = void>(
 params: BooControllerListRulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof booControllerListRules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useBooControllerListRulesSuspense<TData = Awaited<ReturnType<typeof booControllerListRules>>, TError = void>(
 params: BooControllerListRulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof booControllerListRules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List relevance rules for a partner
 */

export function useBooControllerListRulesSuspense<TData = Awaited<ReturnType<typeof booControllerListRules>>, TError = void>(
 params: BooControllerListRulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof booControllerListRules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getBooControllerListRulesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates an include_when or exclude_when rule that applies an operation to products with matching container selections. Requires admin or partner membership.
 * @summary Create a relevance rule
 */
export type booControllerCreateRuleResponse201 = {
  data: RelevanceRuleDto
  status: 201
}

export type booControllerCreateRuleResponse401 = {
  data: void
  status: 401
}

export type booControllerCreateRuleResponse403 = {
  data: void
  status: 403
}

export type booControllerCreateRuleResponse409 = {
  data: void
  status: 409
}
    
export type booControllerCreateRuleResponseSuccess = (booControllerCreateRuleResponse201) & {
  headers: Headers;
};
export type booControllerCreateRuleResponseError = (booControllerCreateRuleResponse401 | booControllerCreateRuleResponse403 | booControllerCreateRuleResponse409) & {
  headers: Headers;
};

export type booControllerCreateRuleResponse = (booControllerCreateRuleResponseSuccess | booControllerCreateRuleResponseError)

export const getBooControllerCreateRuleUrl = () => {


  

  return `/boo/rules`
}

export const booControllerCreateRule = async (createRelevanceRuleDto: CreateRelevanceRuleDto, options?: RequestInit): Promise<booControllerCreateRuleResponse> => {
  
  return customFetch<booControllerCreateRuleResponse>(getBooControllerCreateRuleUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createRelevanceRuleDto,)
  }
);}




export const getBooControllerCreateRuleMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof booControllerCreateRule>>, TError,{data: CreateRelevanceRuleDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof booControllerCreateRule>>, TError,{data: CreateRelevanceRuleDto}, TContext> => {

const mutationKey = ['booControllerCreateRule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof booControllerCreateRule>>, {data: CreateRelevanceRuleDto}> = (props) => {
          const {data} = props ?? {};

          return  booControllerCreateRule(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BooControllerCreateRuleMutationResult = NonNullable<Awaited<ReturnType<typeof booControllerCreateRule>>>
    export type BooControllerCreateRuleMutationBody = CreateRelevanceRuleDto
    export type BooControllerCreateRuleMutationError = void

    /**
 * @summary Create a relevance rule
 */
export const useBooControllerCreateRule = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof booControllerCreateRule>>, TError,{data: CreateRelevanceRuleDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof booControllerCreateRule>>,
        TError,
        {data: CreateRelevanceRuleDto},
        TContext
      > => {

      const mutationOptions = getBooControllerCreateRuleMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Removes a relevance rule by id. Requires admin or membership of the rule's partner.
 * @summary Delete a relevance rule
 */
export type booControllerDeleteRuleResponse204 = {
  data: void
  status: 204
}

export type booControllerDeleteRuleResponse401 = {
  data: void
  status: 401
}

export type booControllerDeleteRuleResponse403 = {
  data: void
  status: 403
}

export type booControllerDeleteRuleResponse404 = {
  data: void
  status: 404
}
    
export type booControllerDeleteRuleResponseSuccess = (booControllerDeleteRuleResponse204) & {
  headers: Headers;
};
export type booControllerDeleteRuleResponseError = (booControllerDeleteRuleResponse401 | booControllerDeleteRuleResponse403 | booControllerDeleteRuleResponse404) & {
  headers: Headers;
};

export type booControllerDeleteRuleResponse = (booControllerDeleteRuleResponseSuccess | booControllerDeleteRuleResponseError)

export const getBooControllerDeleteRuleUrl = (ruleId: string,) => {


  

  return `/boo/rules/${ruleId}`
}

export const booControllerDeleteRule = async (ruleId: string, options?: RequestInit): Promise<booControllerDeleteRuleResponse> => {
  
  return customFetch<booControllerDeleteRuleResponse>(getBooControllerDeleteRuleUrl(ruleId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getBooControllerDeleteRuleMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof booControllerDeleteRule>>, TError,{ruleId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof booControllerDeleteRule>>, TError,{ruleId: string}, TContext> => {

const mutationKey = ['booControllerDeleteRule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof booControllerDeleteRule>>, {ruleId: string}> = (props) => {
          const {ruleId} = props ?? {};

          return  booControllerDeleteRule(ruleId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BooControllerDeleteRuleMutationResult = NonNullable<Awaited<ReturnType<typeof booControllerDeleteRule>>>
    
    export type BooControllerDeleteRuleMutationError = void

    /**
 * @summary Delete a relevance rule
 */
export const useBooControllerDeleteRule = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof booControllerDeleteRule>>, TError,{ruleId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof booControllerDeleteRule>>,
        TError,
        {ruleId: string},
        TContext
      > => {

      const mutationOptions = getBooControllerDeleteRuleMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Sets the full override row for a (product, operation) pair. To clear an override, pass is_excluded=false with null cycle_time/headcount.
 * @summary Upsert a per-product operation override
 */
export type booControllerSetOverrideResponse204 = {
  data: void
  status: 204
}

export type booControllerSetOverrideResponse401 = {
  data: void
  status: 401
}
    
export type booControllerSetOverrideResponseSuccess = (booControllerSetOverrideResponse204) & {
  headers: Headers;
};
export type booControllerSetOverrideResponseError = (booControllerSetOverrideResponse401) & {
  headers: Headers;
};

export type booControllerSetOverrideResponse = (booControllerSetOverrideResponseSuccess | booControllerSetOverrideResponseError)

export const getBooControllerSetOverrideUrl = (productId: string,
    operationId: string,) => {


  

  return `/boo/products/${productId}/operations/${operationId}`
}

export const booControllerSetOverride = async (productId: string,
    operationId: string,
    productOperationOverrideInputDto: ProductOperationOverrideInputDto, options?: RequestInit): Promise<booControllerSetOverrideResponse> => {
  
  return customFetch<booControllerSetOverrideResponse>(getBooControllerSetOverrideUrl(productId,operationId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      productOperationOverrideInputDto,)
  }
);}




export const getBooControllerSetOverrideMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof booControllerSetOverride>>, TError,{productId: string;operationId: string;data: ProductOperationOverrideInputDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof booControllerSetOverride>>, TError,{productId: string;operationId: string;data: ProductOperationOverrideInputDto}, TContext> => {

const mutationKey = ['booControllerSetOverride'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof booControllerSetOverride>>, {productId: string;operationId: string;data: ProductOperationOverrideInputDto}> = (props) => {
          const {productId,operationId,data} = props ?? {};

          return  booControllerSetOverride(productId,operationId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BooControllerSetOverrideMutationResult = NonNullable<Awaited<ReturnType<typeof booControllerSetOverride>>>
    export type BooControllerSetOverrideMutationBody = ProductOperationOverrideInputDto
    export type BooControllerSetOverrideMutationError = void

    /**
 * @summary Upsert a per-product operation override
 */
export const useBooControllerSetOverride = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof booControllerSetOverride>>, TError,{productId: string;operationId: string;data: ProductOperationOverrideInputDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof booControllerSetOverride>>,
        TError,
        {productId: string;operationId: string;data: ProductOperationOverrideInputDto},
        TContext
      > => {

      const mutationOptions = getBooControllerSetOverrideMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    